import * as actions from "../actions/actionTypes/index";

const GameMarketsListReducer = (state = {}, action) => {
    switch (action.type) {
        case actions.GAME_MARKETS_LIST_UPDATE_RECEIVED:
            return {
                ...state,
                [action.key]: {
                    ...state.games,
                    ...action.payload
                }
            };
        case actions.RESET_GAME_MARKETS_LIST:
            return action.key
                ? {
                    [action.key]: undefined
                }
                : {

                };
        default :
            return state;
    }
};

export default GameMarketsListReducer;
